import React from "react";

import { MainLayout } from "../templates";

export default function NotFound() {
  return (
    <MainLayout>
      <div className="mt-5">
        <h1 className="pt-2 text-white">Not found</h1>
      </div>
    </MainLayout>
  );
}
